export default __webpack_public_path__ + "static/register_bg-2978dee5e26316549b37253a0dfbe857.jpg";